export const filterPersonList = (personList: Array<any>, searchText: string) => {
  return personList.filter(
    (person) =>
      person?.nameFullLocal?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1 ||
      person?.personId === searchText ||
      person?.dcPersonId === searchText
  );
};
